var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-logo"},[_c('a',{attrs:{"href":_vm.doxoUrl}},[_c('div',{staticClass:"nav-logo__top-image"})]),_c('a',{attrs:{"href":_vm.tryDoxoPlusUrl}},[_c('div',{staticClass:"nav-logo__bottom-image"})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e801e738","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/common/NavLogo.vue
// module id = null
// module chunks = 